import script from "./ATextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./ATextarea.vue?vue&type=script&setup=true&lang=js"

import "./ATextarea.vue?vue&type=style&index=0&id=11684ac6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11684ac6"]])

export default __exports__